<template>
  <v-container fluid class="custom-container">

    <!-- Folders Header -->

    <v-layout
      v-if="!isEmpty(groupedFolders)"
      class="mb-0 list-folders-actions"
      justify-space-between
    >
      <v-flex xs4>
        <strong v-if="!isEmpty(activeFolderFilterType)">Filtrado por:</strong>
        <v-chip
          v-if="!isEmpty(activeFolderFilterType)"
          close
          @input="resetFolders"
          color="white"
        >{{ activeFolderFilterType.name }}</v-chip>
      </v-flex>
      <v-flex xs4>
        <span>Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
        <v-btn icon @click="pageNumber--" :disabled="pageNumber <= 1">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon @click="pageNumber++" :disabled="pageNumber >= pages">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-select
          v-model="orderFilter"
          :items="orderFilters"
          item-text="name"
          return-object
          hide-details
          solo
          flat
        />
      </v-flex>
    </v-layout>

    <!-- Folders List -->

    <section class="folders">
      <v-layout
        class="folder-list mt-4"
        v-for="(group,index) in groupedFolders"
        :key="index"
        column
      >
        <span
          class="subheading grey--text my-2 text-capitalize"
        > {{ index }}</span>

        <div class="elevation-1 group" v-if="group.length > 0">
          <draggable :options="{ delay: dragDelay }">
            <v-layout
              class="item"
              :class="[folderNotReceivedClass(folder), {'dragging': folder.id === draggingItemId}]"
              v-for="folder in group"
              :key="folder.id"
              @click.stop="openFolder(folder.id)"
              justify-center
              align-center
              row
              wrap
              @dragstart="startDrag(folder.id)"
              @dragend="setDraggingItem(null)"
              @mousedown="startTimer(folder.id)"
              @mouseup="stopTimer"
              @mouseleave="stopTimer"
            >
              <v-flex class="pa-2" xs4>
                <v-menu open-on-hover top offset-y style="width: 100%">
                  <v-layout class="folder-name" align-center row slot="activator">
                    <img
                      class="d-flex mx-3 folder-icon"
                      :src="folderIcon(folder)"
                      alt="Ícone de Pasta"
                    >
                    <v-layout column >
                      <v-flex class="grey--text">
                        <span class="caption process-number">{{ folder.process_number }}</span>
                      </v-flex>
                      <v-flex class="type-name">
                        <span>{{ folder.folder_type.name }}</span>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                  <v-card dark class="pa-2" v-if="folder.subject">
                    <span class="grey--text"> {{folder.subject}}</span>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex class="pa-2" xs3 xl4>
                <v-chip color="grey-lighten-2 entity-chip">
                  <v-avatar size="16" color="white">
                    <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                  </v-avatar>
                  <strong class="grey--text text--darken-2 text-truncate">{{ folder.entity.name }}</strong>
                </v-chip>
              </v-flex>

              <v-flex class="pa-2" xs3 xl2>
                <v-layout justify-center>
                  <current-owner :folder="folder" />
                </v-layout>
              </v-flex>

              <v-flex class="pa-2" xs2>
                <v-layout justify-center>
                  <v-icon v-if="!isEmpty(folder.limit_date)" size="22" class="mr-2">mdi-clock-fast</v-icon>
                  <span class="caption"><term-component :folder="folder"></term-component></span>
                </v-layout>
              </v-flex>

              <span class="folder-border"></span>
            </v-layout>
          </draggable>
        </div>
      </v-layout>
    </section>

    <!-- Empty Content -->
    <v-container fill-height v-if="isEmpty(groupedFolders) && !loading.show">
      <v-layout column align-center justify-center>
        <v-icon class="mb-2" size="48" color="grey darken-2">mdi-inbox</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
          Não há itens para exibir
        </span>
      </v-layout>
    </v-container>


    <v-dialog
      v-model="showDialogNotice"
      persistent max-width="450">
      <v-card>
        <v-card-title class="headline green darken-2 white--text" primary-title>{{ currentNotice.title }}</v-card-title>
        <v-card-text class="newLine">{{ currentNotice.body }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="close">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import { isEmpty, truncate } from "lodash";
import acronym from "@/utils/acronym";
import shortName from "@/utils/short-name";
import format from "date-fns/format";
import * as ptLocale from "date-fns/locale/pt";
import bus from "@/utils/event-bus";
import CurrentOwner from "@/components/inbox/CurrentOwner";
import TermComponent from "@/components/inbox/TermComponent";
import foldersService from "../../../../services/FoldersService";
import NoticeService from "@/services/system/NoticeService";
import draggable from "vuedraggable";

export default {
  name: "inbox",
  components: { CurrentOwner, TermComponent, draggable },
  mounted() {
    this.setInboxFoldersTypes();
    bus.$on("folderCreated", () => {
      this.getFolders();
    });
    bus.$on("loadInboxFolder", () => {
      this.getFolders();
    });
    this.getNotices();
  },
  data() {
    return {
      firstRender: true,
      orderFilters: [
        { name: "Menor prazo", property: "limit_date", order: "asc" },
        { name: "Maior prazo", property: "limit_date", order: "desc" },
        {
          name: "Tramitação mais antiga",
          property: "created_at",
          order: "asc"
        },
        {
          name: "Tramitação mais recente",
          property: "created_at",
          order: "desc"
        }
      ],
      orderFilter: {
        name: "Tramitação mais recente",
        property: "created_at",
        order: "desc"
      },
      truncate,
      shortName,
      isEmpty,
      pageNumber: 1,
      rowsPerPage: 20,
      showDialogNotice: false,
      notices: [],
      currentNotice: {},
      currentNoticeIndex: 0,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500
    };
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;

    },
    folderNotReceivedClass(folder) {
      if (folder.current_owner.id === this.user.id) {
        return "received-folder";
      }
      return "";
    },
    folderIcon(folder) {
      if (folder.current_owner.id === this.user.id) {
        return "/static/images/folder/folder-open-icon.svg";
      }
      return "/static/images/folder/folder-closed-icon.svg";
    },

    acronym(string) {
      return acronym(string);
    },
    currentUserIsOwner(currentOwner) {
      return this.user.id === currentOwner.id;
    },
    getFolders(loading = true) {
      if (loading) {
        this.$store.dispatch("toggleLoader", { show: true });
      }

      //const response = this.NoticeService.getUserNotices();
      //console.log("response", response);
      //console.log(this.NoticeService);

      this.$store
        .dispatch("getFoldersInbox", {
          page: this.pageNumber,
          limit: this.rowsPerPage,
          order: this.orderFilter.order,
          sort: this.orderFilter.property,
          searchText: this.searchText || "",
          folderTypeId: this.folderTypeSelected.id || ""
        })
        .finally(() => {
          this.$store.dispatch("toggleLoader", { show: false });
          this.$store.dispatch("setLoadingSearchText", false);
        });
      this.$store.dispatch("getFoldersCount");
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    formatDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    formatMonthYear(date) {
      return format(date, "MMMM [de] YYYY", { locale: ptLocale });
    },
    resetFolders() {
      this.pageNumber = 1;
      this.$store.dispatch("setFolderTypeSelected", "");
      // this.$store.dispatch('getFoldersInbox');
      this.$store.dispatch("setActiveFolderFilterType", {});
    },
    setInboxFoldersTypes() {
      foldersService.getFolderTypesOnInbox().then(response => {
        this.$store.dispatch("setFolderTypes", response.data);
      });
    },
    orderDateToString(folder) {
      switch (this.orderFilter.property) {
        case "limit_date":
          return folder.limit_date == null
            ? "Sem limite"
            : this.formatMonthYear(folder.limit_date);
        case "created_at":
          if (folder.last_transaction == null) {
            return "Processos não tramitados";
          }
          return this.formatMonthYear(folder.last_transaction.created_at);
        default:
          return "Sem agrupamento";
      }
    },
    async getNotices() {
      const response = await NoticeService.getUserNotices().then(response => {
        this.notices = response.data;
        if (this.notices.length > 0) {
          this.currentNotice = this.notices[this.currentNoticeIndex];
          this.showDialogNotice = true;
        }
      });
    },
    close() {
      NoticeService.markNoticeAsViewed(this.currentNotice.id);
      if (this.currentNoticeIndex < this.notices.length - 1) {
        this.showDialogNotice = false;
        this.currentNotice = this.notices[++this.currentNoticeIndex];
        this.showDialogNotice = true;
      } else {
        this.showDialogNotice = false;
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
    activeFolderFilterType() {
      return this.$store.getters.activeFolderFilterType;
    },
    folders() {
      return this.$store.getters.folders;
    },
    received() {
      if (this.$store.getters.folders.length === undefined) {
        return [];
      }

      const received = this.$store.getters.folders.filter(
        item => item.folder_section === "inbox"
      );
      // if (!isEmpty(this.activeFolderFilterType)) {
      //   received = this.$store.getters.folders.filter(
      //     item => item.folder_section === 'inbox',
      //   );
      //   received = received.filter(
      //     item => item.folder_type.id === this.activeFolderFilterType.id,
      //   );
      //   this.$store.dispatch('setFoldersFound', received);
      // }
      return received;
    },
    groupedFolders() {
      const group = {};
      this.received.forEach(folder => {
        if (group[this.orderDateToString(folder)] == null) {
          group[this.orderDateToString(folder)] = [folder];
        } else {
          group[this.orderDateToString(folder)].push(folder);
        }
      });
      return group;
    },
    pages() {
      return this.$store.getters.foldersPagesCount;
    },
    foldersCount() {
      return this.$store.getters.activeTotalFolders;
    },
    pageStart() {
      return this.pageNumber * this.rowsPerPage - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(
        this.pageStart + (this.rowsPerPage - 1),
        this.foldersCount
      );
    },
    searchText() {
      return this.$store.getters.searchText;
    },
    folderTypeSelected() {
      return this.$store.getters.folderTypeSelected;
    }
  },
  watch: {
    pageNumber: {
      handler: "getFolders",
      immediate: true
    },
    searchText(val) {
      if (val === null || val === "" || val.length > 2) {
        this.getFolders(false);
      }
    },
    folderTypeSelected() {
      this.getFolders();
    },
    orderFilter: {
      handler: "getFolders"
    }
  }
};
</script>

<style scoped lang="scss">
.received-folder {
  background: #f2f2f2;
  font-weight: 600 !important;

  &.caption {
    font-weight: 600 !important;
  }
}

.custom-container {
  height: calc(100vh - 48px);
  position: relative;
  overflow: hidden;
}

.folders {
  overflow-y: auto;
  height: 100%;
  margin-top: 24px;
}

.list-folders-actions {
  position: absolute;
  z-index: 4;
  width: 97%;
  background: white;
  margin-top: 6px;
}

.newLine {
  white-space: pre-wrap;
}

.dragging {
  background-color: #005ece;
}
</style>



// WEBPACK FOOTER //
// src/views/folder/list/inbox/Inbox.vue